import { useEffect, useRef, useState } from "react";

// material-ui
import { Box, ClickAwayListener, Divider, Grid, IconButton, Paper, Popper, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// third-party
import PerfectScrollbar from "react-perfect-scrollbar";

// project imports
import MainCard from "ui-component/cards/MainCard";
import Transitions from "ui-component/extended/Transitions";

// assets
import { IconBell } from "@tabler/icons";
import { useSelector } from "react-redux";
import PedidosList from "./PedidosList";

// ==============================|| NOTIFICATION ||============================== //

const NotificationSection = () => {
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down("md"));

  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");
  const [showBadge, setShowBadge] = useState(false);
  /**
   * anchorRef is used on different componets and specifying one type leads to other components throwing an error
   * */
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  const { notifications } = useSelector((state) => state.menu);
  const { pedidos, cargando } = useSelector((state) => state.pedidos);

  const pedidosIngresados = pedidos.filter((pedido) => pedido.estado === "INGRESADO");

  useEffect(() => {
    setShowBadge(notifications.some((item) => item.estado === 0));
    setShowBadge(!!pedidosIngresados.length);
  }, [notifications, pedidosIngresados]);
  const handleChange = (event) => setValue(event?.target.value);

  return (
    <>
      <Box sx={{ position: "relative" }}>
        <IconButton
          ref={anchorRef}
          aria-controls={open ? "notification-menu" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          sx={{
            position: "relative",
            background: theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[100],
            border: `1px solid ${theme.palette.divider}`,

            "&:hover": {
              background: theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[200],
              transform: "scale(1.05)",
            },
            transition: "all 0.2s ease-in-out",
          }}>
          <IconBell stroke={1.5} size="1.3rem" color={showBadge ? theme.palette.warning.main : theme.palette.text.primary} />
          {showBadge && (
            <Box
              sx={{
                position: "absolute",
                top: -4,
                right: -4,
                width: 20,
                height: 20,
                borderRadius: "50%",
                backgroundColor: theme.palette.error.main,
                color: theme.palette.error.contrastText,
                fontSize: "0.75rem",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: `2px solid ${theme.palette.background.paper}`,
                animation: "pulse 2s infinite",
                "@keyframes pulse": {
                  "0%": {
                    transform: "scale(1)",
                    opacity: 1,
                  },
                  "50%": {
                    transform: "scale(1.1)",
                    opacity: 0.8,
                  },
                  "100%": {
                    transform: "scale(1)",
                    opacity: 1,
                  },
                },
              }}>
              {notifications.filter((item) => item.estado === 0).length}
            </Box>
          )}
        </IconButton>
      </Box>

      <Popper
        placement={matchesXs ? "bottom" : "bottom-end"}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [matchesXs ? 5 : 0, 20],
              },
            },
          ],
        }}>
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClose}>
            <Transitions position={matchesXs ? "top" : "top-right"} in={open} {...TransitionProps}>
              <Paper>
                {open && (
                  <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                    <Grid container direction="column" spacing={2} sx={{ minWidth: "400px" }} padding={2}>
                      <Grid item xs={12}>
                        <Grid container alignItems="center" justifyContent="space-between">
                          {/* <Grid item>
                                                        <Stack direction="row" spacing={2}>
                                                            <Typography variant="subtitle1">All Notification</Typography>
                                                            <Chip
                                                                size="small"
                                                                label="01"
                                                                sx={{
                                                                    color: theme.palette.background.default,
                                                                    bgcolor: theme.palette.warning.dark
                                                                }}
                                                            />
                                                        </Stack>
                                                    </Grid> */}
                          {/* <Grid item>
                                                        <Typography component={Link} to="#" variant="subtitle2" color="primary">
                                                            Mark as all read
                                                        </Typography>
                                                    </Grid> */}
                          <Grid item>
                            <Typography variant="h3">Notificaciones</Typography>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Divider sx={{ py: 1 }} />
                      <Grid item xs={12}>
                        <PerfectScrollbar style={{ height: "100%", maxHeight: "calc(100vh - 205px)", overflowX: "hidden" }}>
                          {/* <Grid container direction="column" spacing={2}>
                                                        <Grid item xs={12}>
                                                            <Box sx={{ px: 2, pt: 0.25 }}>
                                                                <TextField
                                                                    id="outlined-select-currency-native"
                                                                    select
                                                                    fullWidth
                                                                    value={value}
                                                                    onChange={handleChange}
                                                                    SelectProps={{
                                                                        native: true
                                                                    }}
                                                                >
                                                                    {status.map((option) => (
                                                                        <option key={option.value} value={option.value}>
                                                                            {option.label}
                                                                        </option>
                                                                    ))}
                                                                </TextField>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} p={0}>
                                                            <Divider sx={{ my: 0 }} />
                                                        </Grid>
                                                    </Grid> */}

                          {/* <NotificationList /> */}
                          <PedidosList />
                        </PerfectScrollbar>
                      </Grid>
                    </Grid>
                    <Divider />
                    {/* <CardActions sx={{ p: 1.25, justifyContent: 'center' }}>
                                            <Button size="small" disableElevation>
                                                View All
                                            </Button>
                                        </CardActions> */}
                  </MainCard>
                )}
              </Paper>
            </Transitions>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );
};

export default NotificationSection;
